export default __webpack_public_path__ + "static/media/rating_web-sm@2x.7e0dce33.webp";